export const ArrayInterfaceToArrayClass = (
  from: any[],
  to: any,
  ...args: any
) => {
  return from.map((e) => to.fromJson(e, ...args));
};
